import React from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Container,
  Divider,
  Header,
  Image,
  Segment,
} from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import { observer } from 'mobx-react-lite';
import { LoginForm } from '../users/LoginForm';
import { RegisterForm } from '../users/RegisterForm';
import FacebookLogin from '@greatsumini/react-facebook-login';

const HomePage: React.FC = observer(() => {
  const { userStore, modalStore } = useStore();
  return (
    <Segment inverted textAlign="center" vertical className="masthead">
      <Container text>
        <Header as="h1" inverted>
          <Image
            size="massive"
            src="/assets/hubb.png"
            alt="logo"
            style={{ marginBottom: 12, height: 120, width: 120 }}
          />
          theHub
        </Header>
        {userStore.IsLoggedIn ? (
          <>
            <Header
              as="h2"
              inverted
              content={`Welcome back, ${userStore.user?.displayName}`}
              style={{ marginBottom: 32, fontWeight: 200, letterSpacing: 2 }}
            />
            <Button as={Link} to="/activities" size="huge" inverted>
              Go to Activities
            </Button>
          </>
        ) : (
          <>
            <Header
              as="h2"
              inverted
              content="participate, communicate, enjoy"
              style={{ marginBottom: 32, fontWeight: 200, letterSpacing: 3 }}
            />
            <Button
              size="huge"
              inverted
              onClick={() => modalStore.openModal(<LoginForm />)}
            >
              Login!
            </Button>
            <Button
              size="huge"
              inverted
              onClick={() => modalStore.openModal(<RegisterForm />)}
            >
              Register
            </Button>
            {process.env.REACT_APP_FB_ACTIVE === 'true' && (
              <>
                <Divider horizontal inverted>
                  Or
                </Divider>
                <Button
                  as={FacebookLogin}
                  appId="651497123540255"
                  size="huge"
                  inverted
                  color="facebook"
                  content="Login with Facebook"
                  loading={userStore.fbLoading}
                  onSuccess={(response: any) => {
                    console.log('-> Login success: ', response);
                    userStore.facebookLogin(response.accessToken);
                  }}
                  onFail={(response: any) =>
                    console.log('-> Login fail: ', response)
                  }
                />
              </>
            )}
          </>
        )}
      </Container>
    </Segment>
  );
});

export { HomePage };
